import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
}
const qsAll = {
  sections: 'data-section-type="media-slider"',
  videoWrappers: 'data-video-wrapper',
}

const initSection = (section) => {
  const swiper = section.querySelector(`[${qs.swiper}]`)
  const json = JSON.parse(section.querySelector('[type="application/json"]').innerHTML)
  new Swiper(swiper, {
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    spaceBetween: 12,
    breakpoints: {
      320: {
        slidesPerView: json.mobile,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: json.tablet,
      },
      1024: {
        slidesPerView: json.desktop,
        spaceBetween: 24,
      },
      1440: {
        slidesPerView: json.large,
        spaceBetween: 24,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
  section.querySelectorAll(`[${qsAll.videoWrappers}]`).forEach(videoWrapper => {
    const video = videoWrapper.querySelector('video')
    if(video) {
      const control = videoWrapper.querySelector('[data-video-control]')
      const playBtn = videoWrapper.querySelector('.icon-play')
      const pauseBtn = videoWrapper.querySelector('.icon-pause')
      video.addEventListener('click', () => {
        if(video.paused) {
          video.play()
        } else {
          video.pause()
        }
      })
      control.addEventListener('click', () => {
        if(video.paused) {
          video.play()
        } else {
          video.pause()
        }
      })
      video.onended = () => {
        playBtn.classList.remove('hidden')
        pauseBtn.classList.add('hidden')
      }
      video.onpause = () => {
        playBtn.classList.remove('hidden')
        pauseBtn.classList.add('hidden')
      }
      video.onplaying = () => {
        playBtn.classList.add('hidden')
        pauseBtn.classList.remove('hidden')
      } 
    }
  })
}

export const setupMediaSliders = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}